import { useMutation, useQueryClient } from '@tanstack/react-query'

import { post } from '../apiClient'
import { type CreateReservationBody } from '../../../common/validations/reservationSchema'
import {
  CreateReservationResponse,
  CreateReservationResponseSchema,
} from '../../../common/generated/residentApiSchemas'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

export type CreateReservationRequest = CreateReservationBody

export const useAPICreateReservation = (contractId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      request: CreateReservationRequest
    ): Promise<CreateReservationResponse> => {
      const response = await post(
        `/contracts/${contractId}/reservations`,
        request as unknown as Record<string, unknown>,
        CreateReservationResponseSchema
      )
      return response
    },
    throwOnError: false,
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          `${API_ENDPOINTS.CONTRACTS}/${contractId}/reservation-calendars`,
        ],
      })

      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey[0] as string
          return (
            key?.includes(
              `${API_ENDPOINTS.CONTRACTS}/${contractId}/reservation-calendars`
            ) && key?.includes('/time-slots')
          )
        },
      })

      queryClient.invalidateQueries({
        queryKey: ['reservations', contractId],
      })
    },
  })
}
